import React, { useEffect } from 'react';
import { ThemeProvider } from 'styled-components';
import {
  lightTheme,
  MeetingProvider,
  GlobalStyles,
  BackgroundBlurProvider,
  BackgroundReplacementProvider,
  LoggerProvider
} from 'amazon-chime-sdk-component-library-react';
import { ConsoleLogger } from 'amazon-chime-sdk-js';
import { useQueryClient } from '@tanstack/react-query';
import { Appointment } from 'vl-common/src/schemas/shared';
import { Token } from '@hooks/video/useChimeVideoCall';
import Video from './Video';

const VideoContainer = ({
  token,
  clinician_guid,
  patient_guid,
  isClinician = false,
  callStatus,
  sendTokenRequest,
  open,
  endCall,
  appointment
}: {
  token: Token;
  clinician_guid: string;
  patient_guid: string;
  isClinician?: boolean;
  callStatus?: string;
  sendTokenRequest: (
    user_guid: string,
    additionalOptions: {
      clinicianGUID: string;
      patientGUID: string;
    }
  ) => void;
  open?: boolean;
  endCall: () => void;
  appointment: Appointment;
}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    if (callStatus === 'in-progress' && open) {
      sendTokenRequest(isClinician ? clinician_guid : patient_guid, {
        clinicianGUID: clinician_guid,
        patientGUID: patient_guid
      });
      queryClient.invalidateQueries({ queryKey: ['timeline', appointment?.case_id] });
      queryClient.invalidateQueries({ queryKey: ['userTimelineHistory', appointment?.case_id] });
      queryClient.invalidateQueries({ queryKey: ['recordingsAvailability', appointment?.case_id] });
    }
  }, [clinician_guid, patient_guid, isClinician, open, sendTokenRequest]);
  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      <BackgroundReplacementProvider>
        <BackgroundBlurProvider>
          <LoggerProvider logger={new ConsoleLogger('Chime', 3)}>
            <MeetingProvider>
              <Video
                clinician_guid={clinician_guid}
                patient_guid={patient_guid}
                isClinician={isClinician}
                token={token}
                endCall={endCall}
                appointment={appointment}
              />
            </MeetingProvider>
          </LoggerProvider>
        </BackgroundBlurProvider>
      </BackgroundReplacementProvider>
    </ThemeProvider>
  );
};

export default VideoContainer;
